import React from "react";
import { graphql } from 'gatsby';
import styled from "styled-components";
import SEO from '../components/Seo';
import Layout from "../components/Layout";
import Paragraph from "../components/Paragraph/Paragraph";
import CardsContainer from "../components/CardsContainer/CardsContainer";
import Gallery from "../components/Gallery/Gallery";

// Inner Components
const Title = styled.h3`
  color: #B6936C;
  font-weight: bold;
  text-transform: uppercase;
  width: 60%;
  margin: 50px auto 20px auto;
  font-size: 35px;
`;

const AboutPage = ({
  data: {
    allStrapiAbout: { nodes: about },
    allStrapiGalleries: { nodes: gallery }
  }
}) => {

  const {
    cards,
    paragraphOne,
    paragraphTwo,
    headerImage,
    cardOneImage,
    cardTwoImage,
    cardThreeImage,
    cardFourImage,
  } = about[0];

  return (
    <Layout>
      <SEO
        pageTitle={'A Feira e o Dão'}
        description={'Página oficial da Feira do Vinho do Dão - programa, imagens e noticias ao momento'}
      />
      <Paragraph
        title={paragraphOne.title}
        columnOne={paragraphOne.columnOne}
        columnTwo={paragraphOne.columnTwo}
        image={headerImage}
        showImage
      />
      <Paragraph
        title={paragraphTwo.title}
        columnOne={paragraphTwo.columnOne}
        columnTwo={paragraphTwo.columnTwo}
      />
      <CardsContainer
        cards={cards}
        images={[
          cardOneImage,
          cardTwoImage,
          cardThreeImage,
          cardFourImage
        ]}
      />
      <Title>Momentos das Edições Anteriores</Title>
      <Gallery gallery={gallery} />
    </Layout>
  );
};

export const query = graphql`
  {
    allStrapiGalleries {
      nodes {
        id
        image {
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    allStrapiAbout {
      nodes {
        paragraphTwo {
          title
          columnTwo
          columnOne
        }
        paragraphOne {
          title
          columnTwo
          columnOne
        }
        headerImage {
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        cards {
          title
          content
          id
        }
        cardTwoImage {
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        cardThreeImage {
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        cardOneImage {
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        cardFourImage {
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`;

export default AboutPage;
